import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from 'components/custom';
import { getNodeLabel } from '../integrations/ui';
import { filterValue } from '../skyla/helpers';
import { useMappings } from '../skyla/mappings';
export const NodeInputSubmit = ({ node, attributes, setValue, disabled, dispatchSubmit, }) => {
    const { getButtonText } = useMappings();
    return (_jsx(_Fragment, { children: _jsx(Button, { name: attributes.name, onClick: (e) => {
                // Prevent double submit issues.
                e.stopPropagation();
                e.preventDefault();
                // On click, we set this value, and once set, dispatch the submission!
                void setValue(filterValue(attributes.value)).then(async () => dispatchSubmit(e));
            }, value: filterValue(attributes.value)?.toString() ?? '', disabled: attributes.disabled || disabled, type: "submit", fullWidth: true, size: "large", color: "secondary", variant: "contained", children: getButtonText(node, getNodeLabel(node)) }) }));
};
